export const gridStyles = {
    '& .vspacegrid.notEditable': {
        color: 'primary.main'
    }
}